import { render } from "./AIToolTestResults.vue?vue&type=template&id=36cb6116&scoped=true"
import script from "./AIToolTestResults.vue?vue&type=script&lang=js"
export * from "./AIToolTestResults.vue?vue&type=script&lang=js"

import "./AIToolTestResults.vue?vue&type=style&index=0&id=36cb6116&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-36cb6116"]])

export default __exports__